const React = require('react')
const ReactDOM = require('react-dom')

const App = require('./App')

ReactDOM.render(<App />, document.getElementById('root'))



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/